import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import { Spinner } from 'components';

import {
  FinderColumn,
  ColumnList,
  ColumnItem,
  ColumnItemName,
  ColumnItemArrow,
} from 'apps/finder/styles';

@observer
export class FolderColumn extends React.Component {
  render() {
    const { folder, manager, index } = this.props;
    const { filesQueryLoading } = manager;
    if (!folder || filesQueryLoading) {
      return (
        <FinderColumn>
          <Spinner margin='30px auto' />
        </FinderColumn>
      );
    }
    const { input, SelectFile } = manager;
    const { files } = folder;
    return (
      <FinderColumn>
        <ColumnList>
          {files.map((item, i) => {
            const selected = input.split('/')[2 + index] === item.filename;
            const active = item.isFolder
              ? input.endsWith(`/${item.filename}/`)
              : input.endsWith(`/${item.filename}`);
            return (
              <ColumnItem
                key={i}
                onClick={() => SelectFile(item, index)}
                selected={selected}
                active={selected && active}
              >
                <ColumnItemName>{item.filename}</ColumnItemName>
                {item.isFolder ? (
                  <ColumnItemArrow active={active}>&#8250;</ColumnItemArrow>
                ) : null}
              </ColumnItem>
            );
          })}
        </ColumnList>
      </FinderColumn>
    );
  }
}

FolderColumn.propTypes = {
  manager: PropTypes.object,
  folder: PropTypes.object,
  index: PropTypes.number,
};
